import { useEffect, useState } from 'react';

import { CategoryResponse, categoryDataService } from 'services/category.service';

import { useFetch } from './useFetch';

interface CategoryWithAction extends CategoryResponse {
  action: string[];
}

const useNotificationsCategories = () => {
  const [categories, setCategories] = useState<CategoryWithAction[]>([]);

  const { data, refetch, isLoading } = useFetch(() => categoryDataService.getAll(), []);

  useEffect(() => {
    if (data) {
      const mapped = data.map((item: CategoryResponse) => ({
        ...item,
        action: ['edit', 'delete'],
      }));
      setCategories(mapped);
    }
  }, [data]);

  return { categories, refetchCategories: refetch, isLoading };
};

export { useNotificationsCategories };
